export function createUiVariantPlugin({ source } = {}) {
    const read = source ?? (() => document.body.dataset.uiVariant ?? 'v1')
    return {
        install(app) {
            const variant = read()
            app.provide('uiVariant', variant)
            app.config.globalProperties.$uiVariant = variant
        },
    }
}
